<div class="page">
  <div>
    @if (sheet_ready) {
      <equipment-sheet-view [components]="components" [equipment]="equipment"></equipment-sheet-view>
    }
  </div>
</div>
